import templateAdmin from '../../../../Template/config/components/adminView'
import adminConfigManager from './adminConfigManager'

export default {
    ...templateAdmin,
    adminConfigManager
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/adminView/index.js